import { observable, computed, action } from 'mobx';
import CompanyStore from './CompanyStore';
import { API_URL } from '../constants/constants';
import NotificationStore from './NotificationStore';

class FilterStore {
  @observable
  public listOfFilters: Array<string>;

  private companyStore: CompanyStore;
  private notificationStore: NotificationStore;

  constructor(
    companyStore: CompanyStore,
    notificationStore: NotificationStore
    ) {
    this.listOfFilters = [];
    this.companyStore = companyStore;
    this.notificationStore = notificationStore;
  }

  @computed
  get brandFilters() {
    return this.listOfFilters;
  }

  @action
  async fetchFilters() {
    const token = localStorage.getItem('token');
    const company = this.companyStore.selectedCompany;
    const url = `${API_URL}/v1/brand-filters?company=${company}`;
    const headers = new Headers();

    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const brandFilterData = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include'
    })
    .then(res => res.json())
    .catch(err => {
      const error = {
        type: 'error',
        message: err.message + ': Virhe suodattimia hakiessa.',
        seen: false
      };

      this.notificationStore.addNotification(error);
      return { error: err };
    });

    if (!brandFilterData.error) {
      this.listOfFilters = brandFilterData;
    }
  }
}

export default FilterStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/FilterStore.ts